import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ExcelSheet from 'react-export-excel/dist/ExcelPlugin/elements/ExcelSheet';
import ExcelColumn from 'react-export-excel/dist/ExcelPlugin/elements/ExcelColumn';
import ExcelFile from 'react-export-excel/dist/ExcelPlugin/components/ExcelFile';
// IconButton n'est plus utilisé directement ici si on le remplace par un span + FontAwesomeIcon
// import IconButton from '../components/common/IconButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; // Assurez-vous que c'est importé
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';

const ExportPartners = ({ partners }) => {
  const [cleanData, setCleanData] = useState([]);
  // tmpCleanData devrait être initialisé à l'extérieur de useEffect ou géré différemment pour éviter les problèmes de stale closure si useEffect a des dépendances complexes.
  // Pour cet exemple, je garde la logique existante mais c'est un point d'attention.

  useEffect(() => {
    let tmpCleanDataLocal = []; // Utiliser une variable locale pour l'accumulation
    partners.map(partner => {
      // Assurez-vous que partner.originalObject existe
      const originalPartner = partner.originalObject || partner;

      if (
        !originalPartner?.users ||
        (originalPartner?.users && originalPartner?.users.length === 0)
      ) {
        tmpCleanDataLocal.push({
          partner: originalPartner?.name || ''
        });
      } else if (originalPartner.users && originalPartner.users.length > 0) {
        originalPartner.users.map(user => {
          let cleanedCode = {
            partner: originalPartner.name || '',
            description: originalPartner.description || '',
            category_name: originalPartner.category_name || '',
            // Assurez-vous que lastname, firstname, etc. existent dans user
            lastname: user.lastname || '',
            firstname: user.firstname || '',
            roles: user.partner_roles?.map(r => r.title).join(', ') || '',
            email: user.email || '',
            phone: user.phone || '',
            login: user.login || '',
            partner_login_allowed:
              user.partner_login_allowed === 1 ? 'Oui' : 'Non'
          };
          tmpCleanDataLocal.push(cleanedCode);
        });
      }
    });
    setCleanData(tmpCleanDataLocal);
  }, [partners]);

  return (
    <>
      {cleanData.length > 0 && (
        <ExcelFile
          element={
            // Remplacer IconButton par un span pour éviter les boutons imbriqués
            // Le style du bouton sera géré par le composant Button parent dans index.js
            <span style={{ cursor: 'pointer' }}>
              {' '}
              {/* Le style de curseur est important pour l'interaction */}
              <FontAwesomeIcon
                icon={faFileExcel}
                transform="shrink-3"
                style={{ marginRight: '5px' }}
              />
              Exporter
            </span>
          }
          filename="partenaires" // Il est bon de spécifier un nom de fichier
        >
          <ExcelSheet data={cleanData} name="Partners">
            <ExcelColumn label="Partenaire" value="partner" />
            <ExcelColumn label="Description" value="description" />
            <ExcelColumn label="Commission d'achat" value="category_name" />
            <ExcelColumn label="Nom" value="lastname" />
            <ExcelColumn label="Prénom" value="firstname" />
            <ExcelColumn label="Rôles" value="roles" />
            <ExcelColumn label="Email" value="email" />
            <ExcelColumn label="Téléphone" value="phone" />
            <ExcelColumn label="Login" value="login" />
            <ExcelColumn
              label="Autorisé espace partenaire ?"
              value="partner_login_allowed"
            />
          </ExcelSheet>
        </ExcelFile>
      )}
    </>
  );
};

ExportPartners.propTypes = {
  partners: PropTypes.array
};

export default ExportPartners;
